import { render, staticRenderFns } from "./OnlineBoxes.vue?vue&type=template&id=10e2a448&scoped=true&"
import script from "./OnlineBoxes.vue?vue&type=script&lang=js&"
export * from "./OnlineBoxes.vue?vue&type=script&lang=js&"
import style0 from "./OnlineBoxes.vue?vue&type=style&index=0&id=10e2a448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2a448",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10e2a448')) {
      api.createRecord('10e2a448', component.options)
    } else {
      api.reload('10e2a448', component.options)
    }
    module.hot.accept("./OnlineBoxes.vue?vue&type=template&id=10e2a448&scoped=true&", function () {
      api.rerender('10e2a448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OnlineBoxes.vue"
export default component.exports